export default {
  frontend: {
    great: [
      'AngularIo',
      'ReactJS',
      'AngularJS',
      'Responsive',
      'SPA',
      'Typescript',
      'Create-react-app',
      'NextJS',
      'Gatsby',
      'React Native',
      'HTML5',
      'CSS3',
      'Design to Code',
      'Bootstrap',
      'TailwindCSS',
      'SASS',
    ],
    average: [
      'Ionic',
      'Canvas',
      'Gulp',
      'Webpack',
      'Jest',
      'Redux',
      'SSR',
      'XState',
      'Storybook'
    ]
  },
  backend:{
    great: [
      'Ruby on Rails',
      'NodeJS',
      'Ruby',
      'MVC',
      'Mysql',
      'MongoDB',
      'Firebase',
      'GraphQL',
      'OAuth',
      'HLD with design patterns',
      'Microservices',
      'Monolithic',
    ],
    average:[
      'Laravel',
      'Postgres',
      'Python',
      'PHP',
      'ElasticSearch',
      'rspec',
    ]
  },
  inbetween:{
    great: [
      'I18n',
      'LTR-RTL layout changes',
      'WebRTC',
      'Websockets',
      'Video Conferencing',
      'Search Engine Optimization',
      'Wordpress',
      'Gitflow',
      'Landing Pages',
      'API Integrations'
    ],
    average: [
      'Analytics',
      'E2E Tests',
    ]
  },
  devops:{
    great: [
      'Linux Administration',
      'Cron',
      'NGINX',
      'Apache',
      'Docker Containerization',
      'AWS',
      'Digital Ocean',
      'Cloudflare',
      'DNS',
      'CI/CD Pipelines',
    ],
    average: [
      'Google Cloud Platform',
      'Sentry',
      'Serverless Functions',
    ]
  },
  other: {
    great: [
      'Flexible',
      'Analytical',
      'Wireframing',
      'UI Mockups',
      'MVC-prototyping',
      'Generate user stories',
      'Team-player',
      'Value-oriented',
      'Bilingual (fluent english and native arabic)',
    ],
    average: [
      'Agile',
      'Kanban',
      'Jira',
      'Basecamp'
    ]
  }
}